import { Component, Input, HostBinding } from '@angular/core';

import { ThemeName } from './typography.directive';

@Component({
  selector: 'sondermind-icon-label',
  template: `<ng-content></ng-content>`,
  standalone: false
})
export class IconLabelComponent {
  @Input()
  @HostBinding('attr.data-theme')
    theme: ThemeName;

  @Input()
  @HostBinding('attr.data-valign')
    valign: 'baseline' | 'center';

  @HostBinding('class.sondermind-typography')
    bindType = true;

  @HostBinding('class.sondermind-icon-label')
    bindClass = true;
}
